import { Menu, MenuButton, MenuList, MenuItem, Button } from "@chakra-ui/react";
import { ChevronDownIcon, CheckCircleIcon } from "@chakra-ui/icons";
import { useRouter } from "next/router";
import * as analytics from "utils/analytics";
import { requeueIcon } from "./queue-icons";

interface PostTypesDropdownProps {
  selectedType: string;
  onTypeChange: (type: string) => void;
}

export function PostTypesDropdown({ selectedType, onTypeChange }: PostTypesDropdownProps) {
  const router = useRouter();
  const POST_TYPES = {
    schedule: "Scheduled posts",
    published: "Published posts",
    drafts: "Drafts",
    errors: "Errors"
  };

  const handleSelect = (type: string) => {
    onTypeChange(type);
    analytics.log("queue_viewed", {
      type: type,
    });
    router.push({
      pathname: "queue",
      query: { view: "day", type: type },
    });
  };

  return (
    <Menu>
      <MenuButton as={Button} rightIcon={<ChevronDownIcon />} leftIcon={requeueIcon} variant="secondary">
        {POST_TYPES[selectedType] || "Scheduled posts"}
      </MenuButton>
      <MenuList>
        {Object.keys(POST_TYPES).map((type) => (
          <MenuItem key={type} onClick={() => handleSelect(type)}>
            {type === selectedType && <CheckCircleIcon mr={2} />}
            {POST_TYPES[type]}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
} 